<template>
    <section>
        <v-img v-if="journal_id==1"
            :src="require('../../../../assets/library/AM.png')"
            max-height="320"
            contain
            class="ma-0"
            @click="setCurrentTabComponent('AppHomeJournal');setBismenudown(false)">
        </v-img>
        <v-img v-else-if="journal_id==2"
            :src="require('../../../../assets/library/CMJ.png')"
            max-height="320"
            contain
            class="ma-0"
            @click="setCurrentTabComponent('AppHomeJournal');setBismenudown(false)">
        </v-img>
        <v-img v-else
            :src="require('../../../../assets/library/MB.png')"
            max-height="320"
            contain
            class="ma-0"
            @click="setCurrentTabComponent('AppHomeJournal');setBismenudown(false)">
        </v-img>
    </section>
</template>
<script>
export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data(){
        return{
            journal_id:null,
        }
    },
   created(){
       this.journal_id= this.$route.params.journal_id
   }
}
</script>

